namespace advisorop.components.advisor {
    

    class AccountSearchBoxController {
        selectedItem: domains.ISearchAccountResults;
        isAdvisor: boolean;
        isServicer: boolean;
        noNavigate: boolean = false;
        noNavigateCallback: any;

        static $inject = ["advisorService", "generalService", "servicerService", "identityService", "$filter", "$rootRouter"];
        constructor(private advisorService: services.AdvisorService, private generalService: services.GeneralService, private servicerService: services.ServicerService, private identityService: services.IdentityService, public $filter, public $rootRouter) {
        }
        
        searchItems(searchTerm: string): ng.IPromise<Array<{}>> {
            var service = this.isAdvisor ? this.advisorService : (this.isServicer ? this.servicerService : this.advisorService);
            return service.searchAccounts(searchTerm).then((response) => {
                return response.data;
            });
        }

        onSelectItem(item, model, label, event): void {
            if (this.noNavigate) {
            //console.log("NO NAV CALLBACK ITEM IS:", item);
                if (this.noNavigateCallback !== undefined && this.noNavigateCallback !== null) {
                    //console.log("NO NAV CALLBACK IS:", this.noNavigateCallback);
                    this.noNavigateCallback({ id: item.accountId });
                }
            } else {
                if (this.isServicer) {
                    this.servicerService.getAdvisor(item.advisorId)
                        .then(resp => {
                            var advisor = resp.data;
                            if (event && event.src == "household") {
                                if (model.householdId > 0) {
                                    this.goToHouseholdDashboard(advisor);
                                } else {
                                    toastr.warning("Account is not inside of any RTG household");
                                }
                            }
                            else {
                                this.goToAccountSummary(advisor)
                            }
                        }, err => {
                            this.generalService.showError(err);
                        })
                        .finally(() => {
                            this.selectedItem = null;
                        });
                }
                else {
                    if (event && event.src == "household") {
                        if (model.householdId > 0) {
                            this.$rootRouter.navigate(['Advisor', 'AdvisorHouseholdDashboard', { householdId: model.householdId }]);
                        } else {
                            toastr.warning("Account is not inside of any RTG household");
                        }
                    } else {
                        this.$rootRouter.navigate(['Advisor', 'AccountSummary', { accountId: item.accountId }]);
                    }

                    this.selectedItem = null;
                }
            }
        }

        okToImpersonateAdvisor(advisor: domains.IAdvisor): boolean {
            if (advisor.systemLogin && advisor.systemLogin.loginStatus != 1)
                return false;
            else
                return true;
        }

        private impersonateAdvisorAt(advisor: domains.IAdvisor, confirmationMsg: string, landingPage: string): void {
            if (this.okToImpersonateAdvisor(advisor)) {
                if (window.confirm(confirmationMsg)) {
                    // authenticate servicer as advisor 
                    this.identityService.impersonateUser(advisor.systemLogin.username)
                        .then(response => {
                            // clear localstorage
                            localStorage.clear();
                            // redirect page to advisor dashboard
                            window.location.href = landingPage;
                        }).catch(err => toastr.error(`Error ${err.status} ${err.data}`))
                }
            } else {
                if (advisor.systemLogin.loginStatus != 1) {
                    toastr.warning("You can only impersonate users with ACTIVE Login Status.");
                } else {
                    toastr.warning("You can not impersonate this user.");
                }
            }
        }

        goToHouseholdDashboard(advisor: domains.IAdvisor): void {
            this.impersonateAdvisorAt(advisor, `Impersonate ${advisor.fullName} and go to the household dashboard for account "${this.selectedItem.number}"?`, `/advisor/advisorhouseholddashboard/${this.selectedItem.householdId}`);
        }

        goToAccountSummary(advisor: domains.IAdvisor): void {
            this.impersonateAdvisorAt(advisor, `Impersonate ${advisor.fullName} and go to the account summary for account "${this.selectedItem.number}"?`, `/advisor/accountsummary/${this.selectedItem.accountId}`);
        }

        async getAdvisors(id: number) {
            var resp = await this.servicerService.getAdvisors(id)
                .catch(err => this.generalService.showError(err));
            return resp;
        };

        onOpenHousehold = (model) => {
            //console.log("Opening household", model);
        }
      
        $onInit(): void {        
        }

        $routerOnActivate(next, previous) {            
        }
    }

    //title 3 types indvidual , joint more than one, custodian 
    class AccountSearchBox implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.controller = AccountSearchBoxController;
            this.controllerAs = "vm";
            this.bindings = {
                isAdvisor: "<",
                isServicer: "<",
                noNavigate: "<",
                noNavigateCallback: "&"
            };
            this.templateUrl = "spa/advisor-module/components/account-search-box.html";
        }

    }
    angular.module(Constants.APP).component("accountSearchBox", new AccountSearchBox());


}